
import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { NewsService } from './new.service';
import { NewsModel, WorldTravelNews } from '../../../models/centre/news.models';
import { DialogService } from '../../../shared/services/dialog.service';
import { Message } from '../../../models/centre/message.model';
import { NewsDetailService } from './new-detail.service';

@Component({
    selector: 'news-memo-popup',
    templateUrl: 'world-travel.popup.component.html',
    providers: [NewsDetailService]
})

export class WorldTravelPopUpComponent implements OnInit {
    // modifyNewPopupForm: FormGroup;
    public isAssignSuccess = false;
    modifyNewPopupModel = new NewsModel();
    formMessage = '';
    id: any;
    public news: WorldTravelNews;
    public url: string;
    public isSuccess = false;
    public isConfirm;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        public dialogRef: MdDialogRef<WorldTravelPopUpComponent>,
        public dialogService: DialogService,
        public newsDetailService: NewsDetailService,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        if (this.data) {
            this.news = this.data.news;
        }
        // this.newsDetailService.getNewsDetailData(this.data.id).subscribe(
        //     result=>{
        //         if(result){
        //             const data = result.json();
        //             this.arr = data;
        //         }
        //     }
        // );
        this.newsDetailService.downloadFile(this.data.id).subscribe(
            result => {
                if (result) {
                    this.url = result.url;
                }
                else {
                    this.url = "";
                }
            }
        );
    }


    close() {
        this.dialogRef.close(this.isConfirm);
    }

    onConfirm() {
        let param = {
            isConfirm: true
        };
        this.newsDetailService.updateNewsMemo(this.data.id, param).subscribe(
            result => {
                this.isConfirm = true;
                this.close();
            }
        );

    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/news-memo/world-travel-detail.popup.component.ts